import { Box, Button, Theme } from "@mui/material";
import CircledBackButton from "@/features/Common/components/CircledBackButton";
import IconLoader from "@/features/Common/components/IconLoader";
import { shadows } from "@/theme";

interface QuestionnaireHeaderProps {
  showBackButton: boolean;
  onBack: () => void;
  onClose: () => void;
}

export default function QuestionnaireHeader({
  showBackButton,
  onBack,
  onClose,
}: QuestionnaireHeaderProps) {
  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: 1,
      }}
    >
      {showBackButton && (
        <CircledBackButton onClick={onBack} showLabel={true} />
      )}
      <Button
        onClick={onClose}
        color="info"
        sx={{
          borderRadius: "100%",
          boxShadow: shadows.light,
          minWidth: "unset",
          height: (theme: Theme) => theme.spacing(5),
          width: (theme: Theme) => theme.spacing(5),
          ml: "auto",
        }}
      >
        <IconLoader icon="CrossIcon" />
      </Button>
    </Box>
  );
}
